import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { PipesModule } from '@fcom/common/';
import { ComponentsModule } from '@fcom/common/components';
import { GtmModule } from '@fcom/common/gtm';

import { PaymentMethodComponent } from './components/payment-method/payment-method.component';

const COMPONENTS = [PaymentMethodComponent];

@NgModule({
  imports: [CommonModule, ComponentsModule, PipesModule, GtmModule, IconsModule, UiTranslateModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CommonBookingPurchaseSuccessModule {}
